<template>
  <div style="margin-top: 30px; padding:11px;">
    <h2 class="text-center fw-bold mb-3"> İş Yeri Hekimleri</h2>
    <button @click="exportToExcel" class="btn btn-success mb-3">Excel'e Aktar</button>
    <div class="table-responsive">
      <table class="table table-bordered align-middle">
        <thead>
        <tr>
          <th>No</th>
          <th>Personel Adı Soyadı</th>
          <th>Personel Çalışma Saati</th>
          <th>Personel Emekli Durumu</th>
          <th>Personel Çalışma Tipi</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(personal, index) in workplacePhysicianData" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ personal.name }}</td>
          <td>{{ personal.workedHours }}</td>
          <td>{{ personal.workOrRetired ? 'Emekli' : 'Emekli Değil' }}</td>
          <td>{{ personal.workType ? 'Tam Zamanlı' : 'Yarı Zamanlı'}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import * as XLSX from "xlsx";

export default {
  name: "WorkplacePhysicianPage",
  data() {
    return {
      workplacePhysicianData: [],
    }
  },
  created() {
    this.getWorkplacePhysicianData();
  },
  methods: {
    getWorkplacePhysicianData() {
      apiClient.get("personal/getAllWorkplacePhysician").then(res => {
        this.workplacePhysicianData = res.data;
      }).catch(error => {
        console.error("Veri çekme hatası:", error);
      });
    },
    exportToExcel() {
      const data = this.workplacePhysicianData.map((personal, index) => ({
        "No": index + 1,
        "Personel Adı Soyadı": personal.name,
        "Çalışma Saati": personal.workedHours,
        "Emekli Durumu": personal.workOrRetired ? "Emekli" : "Emekli Değil",
        "Çalışma Tipi": personal.workType ? "Tam Zamanlı" : "Yarı Zamanlı"
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "İş Yeri Hekimleri");

      XLSX.writeFile(wb, "is_yeri_hekimleri.xlsx");
    }
  },
}
</script>

<style scoped>
th, td {
  text-align: center;
  vertical-align: middle;
}

h2 {
  font-size: 24px;
  color: #333;
  text-transform: uppercase;
}

button {
  display: block;
  margin: 0 auto 20px;
  padding: 10px 15px;
  font-size: 16px;
}
</style>
